import styled from 'styled-components';

import { ResponsiveButton } from './basic';

const DEFAULT_BACKGROUND = '#efefef';
const HOVER_BACKGROUND = '#dcdcdc';
const SELECTED_BACKGROUND = '#395535';

const SELECTED_CLASS = 'active';

const makeGreenButton = (Component) => styled(Component)`
  border: none !important;

  color: #000 !important;
  background-color: ${DEFAULT_BACKGROUND} !important;

  &:hover {
    background-color: ${HOVER_BACKGROUND} !important;
  }

  &.${SELECTED_CLASS} {
    color: #fff !important;
    background-color: ${SELECTED_BACKGROUND} !important;
  }
`;

const ResponsiveGreenButtonComponent = makeGreenButton(ResponsiveButton);

/**
 * `GreenButton` that is responsive to screen size, via `ResponsiveButton`.
 */
export const GreenButton = ({ active, sizes = ['sm'], ...props }) => (
  <ResponsiveGreenButtonComponent
    {...props}
    sizes={sizes} // (defaults to not being responsive)
    active={active}
    outline={!active}
  />
);
